<template>
    <div
        class="product-basket-count"
        v-bind:class="{ 'product-info-basket-count-tag': lowerPosition  }"
        v-if="basketCount"
    >
        {{ basketCount }}<i class="fa-regular fa-cart-shopping ms-2"></i>
    </div>
</template>

<script>
export default {
    name: "ProductBasketCountFlag",
    props: {
        productId: {
            default: null
        },
        productsBasketCount: {
            default: null,
        },
        product: {
            default: null,
            type: Object
        },
    },
    data() {
        return {
            basketCount: null,
            lowerPosition: false,
        };
    },
    mounted() {
        this.basketCount = this.productsBasketCount ? this.productsBasketCount[this.productId] : null;

        // Set lowerPosition if a tag already exists above this tag.
        if (this.product.tag || this.product.regionClearancePrice || this.product.clearancePrice) {
            this.lowerPosition = true;
        }

        this.$root.$on('basketUpdated', this.updateProductsBasketCount);
    },
    methods: {
        updateProductsBasketCount(basket) {
            this.basketCount = basket.products_basket_count[this.productId];
        }
    }
}
</script>

<style scoped>
.product-basket-count {
    right: 21px;
}
</style>
